if (!customElements.get('cart-consent')) {
  class CartConsent extends HTMLElement {
    handleCheckout = (event) => {
      if (this.checkbox?.checked) {
        this.toggleError(false)
        return
      }

      event.preventDefault()
      event.stopPropagation()
      this.toggleError(true)
    }

    handleChange = (event) => {
      if (event.target.checked) this.toggleError(false)
    }

    connectedCallback() {
      const scope = this.closest('cart-drawer, .cart-buttons-wrapper') || this

      this.checkbox = this.querySelector('.checkbox__input')
      this.error = this.querySelector('[data-cart-consent-error]')
      this.button = scope.querySelector('[data-cart-checkout-button], [data-cart-page-checkout-button]')

      this.button?.addEventListener('click', this.handleCheckout, true)
      this.button?.form?.addEventListener('submit', this.handleCheckout, true)
      this.checkbox?.addEventListener('change', this.handleChange)
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleCheckout, true)
      this.button?.form?.removeEventListener('submit', this.handleCheckout, true)
    }

    toggleError(show) {
      if (this.error) this.error.hidden = !show
      this.checkbox?.setAttribute('aria-invalid', show)
    }
  }

  customElements.define('cart-consent', CartConsent)
}
